import type { AdminDashboardFilterParams } from "../types";

export type AdminHomeFilterSelection = {
  basedOnValue: string | null;
  filterValues: string[];
};

export const mapFiltersToQueryParams = (
  selection: AdminHomeFilterSelection
): AdminDashboardFilterParams => {
  const params: AdminDashboardFilterParams = {};
  const basedOn = selection.basedOnValue;

  if (!basedOn || basedOn === "select") {
    return params;
  }

  for (const filterValue of selection.filterValues) {
    if (filterValue.startsWith("year-")) {
      params.date = filterValue.replace("year-", "");
      continue;
    }

    if (basedOn === "region" && filterValue.startsWith("region-")) {
      params.filter = "region";
      if (filterValue !== "region-all") {
        params.value = filterValue.replace("region-", "");
      }
      continue;
    }

    if (
      basedOn === "revenue_stream" &&
      filterValue.startsWith("revenue_stream-")
    ) {
      params.filter = "revenue_stream";
      if (filterValue !== "revenue_stream-all") {
        params.value = filterValue.replace("revenue_stream-", "");
      }
      continue;
    }
  }

  if (!params.filter) {
    if (basedOn === "region") {
      params.filter = "region";
    } else if (basedOn === "revenue_stream") {
      params.filter = "revenue_stream";
    }
  }

  return params;
};

export const areFilterParamsEqual = (
  left: AdminDashboardFilterParams,
  right: AdminDashboardFilterParams
): boolean =>
  left.filter === right.filter &&
  left.value === right.value &&
  left.date === right.date;
